export default (buildInfo) => console.info(buildInfo.versionInfo);
